export enum ESuepervisorJobExplicitTypes {
    All,
    Include,
    Exclude
}